// ------------------------------------------------------------------------
// -- JS GLOBAL
// ------------------------------------------------------------------------

// ------------------------------------------
// -- MENU - TOGGLE MOBILE NAV
// ------------------------------------------

function toggleNav() {
    var btn = this
    var nav = document.getElementById(this.getAttribute('aria-controls'));
    if ( btn.getAttribute('aria-expanded') === 'true' ) {
        btn.setAttribute('aria-expanded', 'false');
        btn.classList.remove('togglenav--active');
        nav.classList.add('nav--hidden');
    } else {
        btn.setAttribute('aria-expanded', 'true');
        btn.classList.add('togglenav--active');
        nav.classList.remove('nav--hidden');
    }
}
document.getElementById('nav').classList.add('nav--hidden');
document.getElementById('js__toggleNav').addEventListener('click', toggleNav);


// ------------------------------------------
// -- MENU - TOGGLE SUB MENU
// ------------------------------------------

var subs = document.querySelectorAll('.nav__item--parent');
for (var i = 0; i < subs.length; i++) {
    subs[i].querySelector('.nav__sub').classList.add('nav__sub--hidden');
    subs[i].addEventListener('mouseover', openSubHover);
    subs[i].addEventListener('mouseout', closeSubHover);
    subs[i].querySelector('.nav__link').addEventListener('click', toggleSubClick);
    subs[i].addEventListener("keyup", toggleSubKey);
}

function openSubHover() {
    if (window.innerWidth >= 992) {
        var btn = this.querySelector('.nav__link');
        var sub = this.querySelector('.nav__sub');
        if (btn.getAttribute('aria-expanded') === 'false') {
            btn.setAttribute('aria-expanded', 'true');
            sub.setAttribute('aria-hidden', 'false');
            sub.classList.remove('nav__sub--hidden');
        }
    }
}

function closeSubHover() {
    if (window.innerWidth >= 992) {
        var btn = this.querySelector('.nav__link');
        var sub = this.querySelector('.nav__sub');
        if (btn.getAttribute('aria-expanded') === 'true') {
            btn.setAttribute('aria-expanded', 'false');
            sub.setAttribute('aria-hidden', 'true');
            sub.classList.add('nav__sub--hidden');
        }
    }
}

function toggleSubClick() {
    var btn = this;
    var sub = this.nextElementSibling;
    if (btn.getAttribute('aria-expanded') === 'true') {
        btn.setAttribute('aria-expanded', 'false');
        sub.setAttribute('aria-hidden', 'true');
        sub.classList.add('nav__sub--hidden');
    } else {
        btn.setAttribute('aria-expanded', 'true');
        sub.setAttribute('aria-hidden', 'false');
        sub.classList.remove('nav__sub--hidden');
    }
}

function toggleSubKey(e) {
    var btn = this.querySelector('.nav__link');
    var sub = this.querySelector('.nav__sub');
    if (e.keyCode == "27") {
        if (btn.getAttribute('aria-expanded') === 'true') {
            btn.setAttribute('aria-expanded', 'false');
            sub.setAttribute('aria-hidden', 'true');
            sub.classList.add('nav__sub--hidden');
            btn.focus();
        }
    }
}